(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["almond-configurator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-almond-builder]').forEach((builder) => {
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const firstOption = builder.querySelector('[data-almond="milk-chocolate"]');
    const rawOption = builder.querySelector('[data-almond="raw"]');
    const almondDefaults = { firstTitle: firstOption.querySelector('strong').textContent.trim(), firstNote: firstOption.querySelector('small').textContent.trim(), rawTitle: rawOption.querySelector('strong').textContent.trim() };
    const packageLabels = {};
    builder.querySelectorAll('[data-package]').forEach((button) => { packageLabels[button.dataset.package] = button.querySelector('strong').textContent.trim(); });
    let product = 'almonds'; let productTitle = 'Almonds'; let optionTitle = almondDefaults.firstTitle; let packageType = 'flat_bag'; let basePrice = 4.90; let quantity = 250; let discount = 5;
    const selectGroup = (selector, chosen) => { builder.querySelectorAll(selector).forEach((button) => { const active = button === chosen; button.classList.toggle('is-selected', active); button.setAttribute('aria-pressed', String(active)); }); };
    const showImage = (url, alt) => { const photo = builder.querySelector('[data-package-photo]'); const placeholder = builder.querySelector('[data-stage-placeholder]'); if (url) { photo.src = url; photo.alt = alt; photo.hidden = false; placeholder.hidden = true; } else { photo.hidden = true; placeholder.hidden = false; } };
    const update = () => {
      const unit = basePrice * (1 - discount / 100); const total = unit * quantity; const savings = (basePrice - unit) * quantity;
      builder.querySelector('[data-unit-price]').textContent = money.format(unit);
      builder.querySelector('[data-base-price]').textContent = money.format(basePrice);
      builder.querySelector('[data-total]').textContent = money.format(total);
      builder.querySelector('[data-savings]').textContent = money.format(savings);
      builder.querySelector('[data-discount-badge]').textContent = discount + '% volume discount';
      builder.querySelector('[data-summary-product]').textContent = product === 'almonds' ? optionTitle : productTitle;
      builder.querySelector('[data-summary-package]').textContent = packageLabels[packageType];
      builder.querySelector('[data-summary-quantity]').textContent = quantity.toLocaleString() + ' units';
    };
    builder.querySelectorAll('[data-product-choice]').forEach((button) => button.addEventListener('click', () => {
      product = button.dataset.productChoice; productTitle = button.dataset.title; basePrice = Number(button.dataset.price); selectGroup('[data-product-choice]', button);
      showImage(button.dataset.productImage, productTitle);
      if (product === 'almonds') {
        firstOption.querySelector('strong').textContent = almondDefaults.firstTitle; firstOption.querySelector('small').textContent = almondDefaults.firstNote; rawOption.hidden = false; optionTitle = almondDefaults.firstTitle; basePrice = 4.90;
      } else {
        firstOption.querySelector('strong').textContent = productTitle; firstOption.querySelector('small').textContent = 'Standard selection · from ' + money.format(basePrice); rawOption.hidden = true; optionTitle = productTitle;
      }
      selectGroup('[data-almond]', firstOption); update();
    }));
    builder.querySelectorAll('[data-almond]').forEach((button) => button.addEventListener('click', () => { optionTitle = button.querySelector('strong').textContent.trim(); basePrice = Number(button.dataset.price); selectGroup('[data-almond]', button); update(); }));
    builder.querySelectorAll('[data-package]').forEach((button) => button.addEventListener('click', () => { packageType = button.dataset.package; selectGroup('[data-package]', button); showImage(button.dataset.packageImage, packageLabels[packageType]); update(); }));
    builder.querySelectorAll('[data-quantity]').forEach((button) => button.addEventListener('click', () => { quantity = Number(button.dataset.quantity); discount = Number(button.dataset.discount); selectGroup('[data-quantity]', button); update(); }));
    builder.querySelector('[data-logo-input]').addEventListener('change', (event) => { const file = event.target.files[0]; if (!file) return; const preview = builder.querySelector('[data-logo-preview]'); preview.innerHTML = ''; const image = document.createElement('img'); image.src = URL.createObjectURL(file); image.alt = file.name; preview.appendChild(image); builder.querySelector('[data-upload-title]').textContent = 'Logo added'; builder.querySelector('[data-upload-note]').textContent = file.name; });
    builder.querySelector('[data-cta]').addEventListener('click', () => { const toast = builder.querySelector('[data-toast]'); toast.hidden = false; window.setTimeout(() => { toast.hidden = true; }, 2600); });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tae-product-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tae-catalog]').forEach((section) => {
    const frame = section.querySelector('iframe');
    const fitFrame = () => {
      const top = frame.getBoundingClientRect().top + window.scrollY;
      frame.style.height = `${Math.max(360, window.innerHeight - top - 30)}px`;
    };
    fitFrame();
    window.addEventListener('resize', fitFrame);
    window.addEventListener('load', fitFrame, { once: true });
    const origin = 'https://the-amenity-edit-catalog.vercel.app';
    const sendTheme = () => frame.contentWindow.postMessage({ type: 'tae:catalog-theme', customerLoggedIn: section.dataset.customerLoggedIn === 'true', background: section.dataset.background, foreground: section.dataset.foreground, accent: section.dataset.accent, bodyFont: section.dataset.bodyFont, headingFont: section.dataset.headingFont }, origin);
    frame.addEventListener('load', sendTheme);
    window.addEventListener('message', (event) => {
      if (event.origin === origin && event.source === frame.contentWindow && event.data?.type === 'tae:catalog-ready') sendTheme();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
